import Api from '..';

// =============================================================================
// SERVICE: ARRANJOS — Responsáveis
// =============================================================================
// Tipos: manutencao-carrinhos | eventos | aeroporto
//
// GET    /arranjos/:tipo/responsaveis
// GET    /arranjos/:tipo/responsaveis/principal
// POST   /arranjos/:tipo/responsaveis            { usuarioId }
// PATCH  /arranjos/:tipo/responsaveis/:id/principal
// DELETE /arranjos/:tipo/responsaveis/:id
// =============================================================================

const AranjosService = {

  listarResponsaveis: async (tipo) => {
    const response = await Api.get(`/arranjos/${tipo}/responsaveis`);
    return response.data;
  },

  obterPrincipal: async (tipo) => {
    const response = await Api.get(`/arranjos/${tipo}/responsaveis/principal`);
    return response.data;
  },

  adicionarResponsavel: async (tipo, usuarioId) => {
    const response = await Api.post(`/arranjos/${tipo}/responsaveis`, { usuarioId });
    return response.data;
  },

  definirPrincipal: async (tipo, id) => {
    const response = await Api.patch(`/arranjos/${tipo}/responsaveis/${id}/principal`);
    return response.data;
  },

  removerResponsavel: async (tipo, id) => {
    const response = await Api.delete(`/arranjos/${tipo}/responsaveis/${id}`);
    return response.data;
  },
};

export default AranjosService;
